import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Inject,
	Input,
	Output,
	PLATFORM_ID,
	TrackByFunction,
} from '@angular/core';
import { NgFor, NgIf, NgStyle } from '@angular/common';
import {
	ButtonComponent,
	CustomWindow,
	MaybeExternalLinkDirective,
	SvgIconComponent,
	WINDOW,
	isLinkExternal,
} from '@woolworthsnz/styleguide';
import { BannerCarouselApiModel, Roundel } from '@woolworthsnz/trader-api';

@Component({
	selector: 'wnz-hero-item-content',
	standalone: true,
	imports: [ButtonComponent, MaybeExternalLinkDirective, NgIf, NgFor, NgStyle, SvgIconComponent],
	templateUrl: './hero-item-content.component.html',
	styleUrls: ['./hero-item-content.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroItemContentComponent {
	private _item: BannerCarouselApiModel;

	@Input() tabindex: number;
	@Input() currentIndex: number;
	@Input() carouselName?: string | null;

	@Input() set item(value: BannerCarouselApiModel) {
		if (value) {
			this._item = value;
		}
		if (value?.roundels?.length) {
			this.sortedRoundels = value.roundels
				.slice()
				.sort((a: Roundel, b: Roundel) => (a.order && b.order ? a.order - b.order : 0));
		}
	}

	get item(): BannerCarouselApiModel {
		return this._item;
	}

	@Output() tcLinkClicked = new EventEmitter<void>();
	@Output() ctaBtnClicked = new EventEmitter<void>();

	sortedRoundels: Roundel[];

	constructor(@Inject(PLATFORM_ID) private platformId: Object, @Inject(WINDOW) private window: CustomWindow) {}

	trackByRoundelUrl: TrackByFunction<Roundel> = (_, roundel: Roundel) => roundel.url;

	public onClickCtaBtn(): void {
		this.ctaBtnClicked.emit();
	}

	isURLExternal(url: string): boolean {
		return isLinkExternal(this.platformId, url, this.window.location);
	}

	onTcLinkClick(): void {
		this.tcLinkClicked.emit();
	}
}
